import { DomensEnum } from "./env";

export const API_URL = process.env.VUE_APP_API_URL || `${DomensEnum.Demo}/`;
export const AGORA_APP_ID = process.env.VUE_APP_AGORA_APP_ID;
export const STATIC_URL = process.env.NODE_ENV === 'production' ? '' : `${DomensEnum.Demo}/`;